import React from 'react';

const StoryCheckStep = ({ storyAnalysis, theme }) => (
  <section id="gift-builder-preview" className="scroll-mt-6 lumirae-editor-panel p-5">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <div className="text-[10px] font-black uppercase tracking-[0.28em]" style={{ color: theme.accent }}>
          Story Check
        </div>
        <div className="mt-1 text-sm font-black uppercase tracking-tight" style={{ color: theme.text }}>
          {storyAnalysis.momentCount} moments / about {storyAnalysis.estimatedMinutes} min / {storyAnalysis.readiness}/5 ready
        </div>
      </div>
      <div className="flex gap-1">
        {[0, 1, 2, 3, 4].map((step) => (
          <span
            key={step}
            className="h-2 w-8 rounded-full"
            style={{ backgroundColor: step < storyAnalysis.readiness ? theme.accent : theme.cardBorder }}
          />
        ))}
      </div>
    </div>
    {storyAnalysis.issues.length > 0 ? (
      <div className="mt-4 space-y-2">
        {storyAnalysis.issues.slice(0, 3).map((issue) => (
          <div key={issue} className="rounded-2xl bg-white/65 px-4 py-3 text-[10px] font-black uppercase tracking-widest opacity-70">
            {issue}
          </div>
        ))}
      </div>
    ) : (
      <div className="mt-4 rounded-2xl bg-white/65 px-4 py-3 text-[10px] font-black uppercase tracking-widest opacity-70">
        Your story has a clear beginning, emotional peak, and ending.
      </div>
    )}
    <p className="mt-4 text-[9px] font-black uppercase leading-relaxed tracking-[0.16em] opacity-45">
      Use the Publish page to save, preview, or seal after reviewing these checks.
    </p>
  </section>
);

export default StoryCheckStep;
